module.exports = {
   view: {
      main_text: 'Welcome to RUBiS BI Portal',
      sub_text: 'Welcome Back, Please Login to Continue',
      forgot_pass: 'Forgot Password',
      back_login: 'Back to Log In',
      login: 'Log In',
      send_token: 'Send Token',
      validate_otp: 'Validate OTP',
      side_text: 'Welcome to RUBiS BI. This is the default login page provided. Log in to continue the journey',
      verify: 'Verify Email',
      verify_sub: 'Thank You for registering, Provide a password for your account',
      forgot: 'Forgot Password',
      forgot_sub: 'Provide a new password',
      change: 'Change Password',
   },
   model:{
      email: 'Email Address',
      password: 'Password',
      otp: 'OTP Received',
      confirm_pass: 'Confirm Password',
   }
}